import React from 'react';
import Missions from '../components/Missions';

const MissionsPage = () => (
  <>
    <Missions />
  </>
);

export default MissionsPage;
